export const CompletedSubscriberss = [
  {
    "Subscriber Name": "ABCDE",
    PRAN: 400080605197,
    "Subscriber PAN": "AAVPS1234L",
    "Mobile Number": "123456789",
    "EMail ID": "abcdefeee@gmail.com",
    "POP Name": "ABCD",
    Workflownumber: "1111013308A00275565",
    "Agent ReferenceNumber": "AJRPS0211R00022231880",
    "POP Charges": 400.0,
    "PRAN generation Date": "26/03/2022",
  },
];

export const Contributedsubscriberss = [
  {
    "Subscriber Name": "VFDERR",
    PRAN: 400090604705,
    "PRAN generation Date": "25/03/2022",
    "Contribution type": "Initial Contribution",
    "Cont AMount": 50000.0,
    "Tier Type": "Tier-1",
    Source: "ABCDE",
    "POP Name": "JUGTRE",
    "Agent Ref number": "AJRPS0211R00031880",
    "Agent Name": "aasdfaer",
    "Contribution ID": "026123007887869",
    "SCF Status": "Reconciled",
    "SCF Upload date": "30/03/2022",
    "SCF Transaction ID": "2200013166301",
    "POP Charges": 250.0,
    "Unitisation status": "Unitisation Completed",
    "Unitisation Date": "31/03/2022",
  },
];

export const PendingSubscriberss = [
  {
    "Subscriber Name": "HTRRFEE",
    "Subscriber PAN": "ABCPP1234A",
    "Mobile Number": "1234567891",
    "EMail ID": "adfasdfesadfasdf@yahoo.co.in",
    "POP Name": "ABCD",
    Workflownumber: "013308A00296717",
    "Agent ReferenceNumber": "AGQPM2161C00031270",
    "Pending At": "Pending at Scheme Section",
  },
];